import React from 'react'
import { SET_USER, UNSET_USER } from '../actionTypes'
import { IStoreState } from '../types'

interface IAction {
  type: string
  payload: IStoreState['user']
}

const initialState: IStoreState['user'] = {}

export const userReducer: React.Reducer<IStoreState['user'], IAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SET_USER:
      return { ...state, ...action.payload }
    case UNSET_USER:
      return { ...action.payload }
    default:
      return state
  }
}
